<template>
  <el-dialog
    class="vote-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="30vh"
  >
    <el-descriptions class="margin-top" :column="1" :border="true">
      <el-descriptions-item v-for="(item, i) in voteLabel" :key="i">
        <template slot="label">
          {{ item.name }}
        </template>
        <template v-if="item.formatter">
          {{ item.formatter(voteData[item.value]) }}
        </template>
        <template v-else>
          {{ voteData[item.value] || $constants.EMPTY }}
        </template>
      </el-descriptions-item>
    </el-descriptions>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleOk()">投同意票</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VoteDialog',
  data() {
    return {
      title: '投票',
      dialogVisible: false,
      voteLabel: [
        {
          name: '投票事件',
          value: 'VoteType',
          formatter: data => {
            return this.voteEvent(data)
          }
        },
        { name: '议案详情', value: 'VoteDetail' },
        { name: '投票原因', value: 'Reason' }
      ],
      voteData: {}
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen(data) {
      this.voteData = data
      this.dialogVisible = true
    },
    voteEvent(val) {
      let eventList = [
        '节点增加更新',
        '根证书更新',
        '共识删除',
        '更新区块配置',
        '部署合约',
        '更新合约',
        '冻结合约',
        '解冻合约',
        '撤销合约'
      ]
      return eventList[val]
    },
    handleOk() {
      let param = {
        voteId: this.voteData.Id,
        voteResult: 1
      }
      this.$apis.chain.doVote(param).then(res => {
        if (res) {
          this.$message.success('投票成功')
          this.handleCancel()
          this.$emit('update:list')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('vote-dialog', (), ());
.vote-dialog.common-dialog {
  @include adaptation((
    --vote-dialog-body-padding-bottom: 20px
  ));
  /deep/ .el-dialog {
    width: var(--common-dialog-width);

    .el-dialog__body {
      padding-bottom: var(--vote-dialog-body-padding-bottom);
    }
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
